module.exports = __webpack_public_path__ + "img/agree.9fc96200.png";